import React, { Component } from 'react';
import { PrismButton, PrismDialog } from '@prism-ui/react';
import Card from '../Card';
import PageHeader from '../PageHeader';
import { ProfileForm } from '../Profile/ProfileForm';
import { getCommittee } from '../../services/users';
import Permissions from '../../data/PermissionLevel';
import './CommitteeBios.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
class CommitteeBios extends Component {
  state = {
    bios: [],
    chapters: [],
    editingBioId: null,
    filters: {
      chapter: 'Show All',
    },
  };

  componentDidMount = async () => {
    try {
      // BUG FIX: Add try-catch to handle API failures
      let bios = await getCommittee();
      let chapters = this.loadChapters(bios);
      this.setState({ bios, chapters });
    } catch (error) {
      console.error('Failed to load committee bios:', error);
      this.setState({ bios: [], chapters: ['Show All'] });
    }
  };

  loadChapters = (bios) => {
    let locations = bios.map((b) => b.location);
    locations = ['Show All', ...new Set(locations)];
    return locations;
  };

  canEdit = (bio) => {
    let permissionLevel = this.props.currentUser.Role.permission_level;
    let isOfficer = permissionLevel >= Permissions.Officer;
    let isUser = bio.id === this.props.currentUser.user_id;
    return isOfficer || isUser;
  };

  setFilter = (type, value) => {
    let filters = this.state.filters;
    filters[type] = filters[type] !== value ? value : '';
    this.setState({ filters });
  };

  renderBios = () => {
    return this.state.bios.map((b, i) => {
      let filters = this.state.filters;
      if (filters.chapter !== 'Show All' && filters.chapter !== b.location) {
        return null;
      }

      // add the correct file path to profile photos that are stored locally
      if (b && b.photo != null) {
        if (b.photo.trim().length > 0 && b.photo.indexOf('/') < 0) {
          b.photo = `/images/headshots/${b.photo}`;
        }

        // display default.svg when users are missing a profile photo
        if (b.photo.trim().length == 0) {
          b.photo = undefined;
        }

        // all file paths should be absolute
        if (b.photo !== undefined && !b.photo.startsWith('/')) {
          b.photo = `/${b.photo}`;
        }
      }

      return (
        <li key={i} className="bio">
          <Card
            image_src={b.photo || '/images/headshots/default.svg'}
            image_alt={'Headshot of ' + (b.preferred_name || b.name)}
            title={b.preferred_name || b.name}
            subtitles={[
              b.role,
              // eslint-disable-next-line react/jsx-key
              <a
                className="bio-email"
                target="_blank"
                rel="noopener noreferrer"
                href={'mailto:' + b.email.toLowerCase()}
              >
                {b.email.toLowerCase()}
              </a>,
            ]}
            actions={
              this.canEdit(b)
                ? [
                    // eslint-disable-next-line react/jsx-key
                    <PrismButton
                      tone="secondary"
                      display="outline"
                      size="sm"
                      onPrismClick={() => this.setState({ editingBioId: b.id })}
                    >
                      <FontAwesomeIcon icon={faPen} />
                      Edit Profile
                    </PrismButton>,
                  ]
                : ''
            }
          >
            <div className={'bio-details'}>
              {b.bio
                ? b.bio.split('\n').map((x, i) => <p key={i}>{x}</p>)
                : null}
            </div>
          </Card>
        </li>
      );
    });
  };

  handleProfileSaved = async () => {
    this.setState({ editingBioId: null });
    try {
      const bios = await getCommittee();
      this.setState({ bios, chapters: this.loadChapters(bios) });
    } catch (error) {
      console.error('Failed to refresh committee bios:', error);
    }
  };

  renderEditDialog() {
    const { editingBioId } = this.state;
    if (!editingBioId) return null;

    return (
      <PrismDialog
        open
        close-method="user"
        setAriaLabel="Edit Profile"
        onPrismClose={() => this.setState({ editingBioId: null })}
      >
        <span slot="header">Edit Profile</span>
        <div className="profile-edit-body">
          {/* `key` forces a fresh mount per bio so the form refetches rather than
              showing the previously edited profile. */}
          <ProfileForm
            key={editingBioId}
            embedded
            params={{ user_id: editingBioId }}
            currentUser={this.props.currentUser}
            onClose={() => this.setState({ editingBioId: null })}
            onSaved={this.handleProfileSaved}
          />
        </div>
      </PrismDialog>
    );
  }

  render() {
    return (
      <main>
        <PageHeader title="Committee Members" />

        <div className="committee-filters">
          {this.state.chapters.map((c) => {
            const selected = this.state.filters.chapter === c;
            return (
              <PrismButton
                tone="primary"
                display={selected ? 'fill' : 'link'}
                key={c}
                onPrismClick={() => this.setFilter('chapter', c)}
              >
                {c}
              </PrismButton>
            );
          })}
        </div>
        <ul className="bio-list">{this.renderBios()}</ul>
        {this.renderEditDialog()}
      </main>
    );
  }
}

export default CommitteeBios;
